export {FrntIcon} from './frnt-icon'
